import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';
const baseFruits = [
  { name: "Banana", img: "🍌" },
  { name: "Apple", img: "🍎" },
  { name: "Mango", img: "🥭" },
  { name: "Pineapple", img: "🍍" },
  { name: "Watermelon", img: "🍉" }
];

const getRandomPrice = () => parseFloat((Math.random() * 4 + 1).toFixed(2)); // $1.00 to $5.00

const SupermarketSafari = () => {
  const [fruits, setFruits] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [estimate, setEstimate] = useState('');
  const [result, setResult] = useState('');

  useEffect(() => {
    generateNewFruits();
  }, []);

  const generateNewFruits = () => {
    const updated = baseFruits.map(fruit => ({
      ...fruit,
      price: getRandomPrice()
    }));
    setFruits(updated);
    setSelectedItems([]);
    setEstimate('');
    setResult('');
  };

  const handleSelect = (fruit) => {
    if (selectedItems.length < 3 && !selectedItems.includes(fruit)) {
      setSelectedItems([...selectedItems, fruit]);
    }
  };

  const checkEstimate = () => {
    const roundedTotal = selectedItems.reduce(
      (sum, item) => sum + Math.round(item.price),
      0
    );
    const userEstimate = parseFloat(estimate);

    if (isNaN(userEstimate)) {
      setResult("❗ Please enter a valid number.");
      return;
    }

    if (Math.abs(userEstimate - roundedTotal) <= 1) {
      setResult(`✅ Great job! Rounded total: $${roundedTotal}`);
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResult(`❌ Try again. Your estimate was $${userEstimate}, correct total is $${roundedTotal}`);
    }
  };

  const styles = {
    container: {
      fontFamily: "'Comic Sans MS', cursive",
      background: "#e8f5e9",
      padding: "2rem 1rem",
      textAlign: "center",
      minHeight: "100vh",
      boxSizing: "border-box"
    },
    title: {
      color: "#2e7d32",
      fontSize: "clamp(1.8rem, 5vw, 2.5rem)",
      marginBottom: "1rem"
    },
    store: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
      gap: "20px",
      justifyItems: "center",
      margin: "1rem auto",
      maxWidth: "800px"
    },
    item: {
      background: "#fff",
      border: "3px solid #66bb6a",
      borderRadius: "15px",
      padding: "15px",
      cursor: "pointer",
      transition: "transform 0.2s",
      fontSize: "clamp(1rem, 2vw, 1.1rem)",
      width: "100%",
      maxWidth: "140px",
      boxSizing: "border-box"
    },
    price: {
      fontSize: "clamp(1rem, 2vw, 1.2rem)",
      fontWeight: "bold",
      color: "#1b5e20"
    },
    section: {
      marginTop: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    input: {
      padding: "10px",
      fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
      width: "120px",
      borderRadius: "8px",
      border: "2px solid #43a047",
      textAlign: "center",
      marginTop: "10px"
    },
    button: {
      padding: "12px 24px",
      fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
      backgroundColor: "#43a047",
      color: "white",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
      marginTop: "20px"
    },
    result: {
      fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
      marginTop: "20px",
      fontWeight: "bold",
      maxWidth: "600px",
      textAlign: "center"
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🛒 Supermarket Safari</h1>
      <p>Click on 3 fruits, round their prices, and estimate the total!</p>

      <div style={styles.store}>
        {fruits.map((fruit, i) => (
          <div
            key={i}
            style={styles.item}
            onClick={() => handleSelect(fruit)}
          >
            <div style={{ fontSize: "clamp(2rem, 5vw, 3rem)" }}>{fruit.img}</div>
            <div>{fruit.name}</div>
            <div style={styles.price}>${fruit.price.toFixed(2)}</div>
          </div>
        ))}
      </div>

      {selectedItems.length > 0 && (
        <div style={styles.section}>
          <h3>Your Selected Fruits</h3>
          {selectedItems.map((item, index) => (
            <div key={index}>
              {item.img} {item.name} → Rounded: ${Math.round(item.price)}
            </div>
          ))}
        </div>
      )}

      <div style={styles.section}>
        <label>Enter your estimated total:</label>
        <input
          type="number"
          value={estimate}
          onChange={(e) => setEstimate(e.target.value)}
          style={styles.input}
        />
        <button onClick={checkEstimate} style={styles.button}>
          Check Answer
        </button>
      </div>

      {result && (
        <div style={styles.section}>
          <div style={styles.result}>{result}</div>
          <button onClick={generateNewFruits} style={styles.button}>
            Next Question ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default SupermarketSafari;
